// extracted by mini-css-extract-plugin
module.exports = {"InfListFooterText":"InfListFooterText--_Yuu0"};